var path = 'app/scripts/modules/core/src/validation/validationError.html';
var html = "<div class=\"error-message\">\n  <span class=\"fa fa-exclamation-circle\"></span> {{message}}\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/validation/validationError.html
// module id = 1132
// module chunks = 0